
export enum Permissions {

    Applications = 100,
    ApplicationProgress = 101,
    ApplicationOnboarding = 103,
    ApplicationMilestones = 104,
    ApplicationContact = 105,
    ApplicationForwardCv = 106,
    ApplicationAddToVacancy = 107,
    ApplictionOfferSkip = 108,
    ApplicationAnonymous = 109,
    ApplicationRtw = 110,
    ApplicationProgressLocked = 111,
    ApplicationBypassCompulsoryStage = 112,
    ApplicationSuperLock = 113,
    ApplicationSuperUnlock = 114,
    ApplicationEdit = 115,
    Talent = 200,

    Assessment = 300,

    Reports = 400,
    ReportsATS = 401,
    ReportsGA = 402,

    Onboarding = 500,

    ApplicationAssessments = 600,
    ApplicationAssessmentKnockout = 601,
    ApplicationAssessmentFreetext = 602,
    ApplicationAssessmentSjtVn = 603,
    // ApplicationCustomForms = 604,

    FullSystemRights = 0,
    System = 1000,
    SystemUsers = 1001,
    SystemEmails = 1002,
    SystemLocations = 1003,
    SystemCalendar = 1004,
    SystemSuppliersSMS = 1006,
    SystemSuppliersMedia = 1007,
    SystemAgent = 1008,
    SystemChangeUser = 1009,
    SystemBusinessAreas = 1011,
    SystemBrands = 1012,
    SystemRewards = 1013,
    SystemQualites = 1014,
    Vacancies = 1,
    VacanciesCreate = 2,
    VacanciesView = 3,
    VacanciesEdit = 4,
    VacanciesTemplate = 7,
    VacancyProcess = 8,
    VacancyInterviews = 11,
    VacanciesCreateFromTemplate = 12,
    VacanciesSkipAuth = 14,
    VacanciesJobBoards = 9,
    VacanciesPSL = 13,
    DashboardChangeUser = 1009,
    Organisations = 700,
    OrganisationUser = 701,
}

[
    { PrivilegeId: 5, Name: 'Vacancies-Create-Authoriser', FriendlyName: 'Vacancies - Manually Create Authoriser' },
    { PrivilegeId: 6, Name: 'Vacancies-Create-Interviewer', FriendlyName: 'Vacancies - Manually Create Interviewer' },

    { PrivilegeId: 9, Name: 'Vacancies-JobBoards', FriendlyName: 'Vacancies – Launch To Jobboards' },
    { PrivilegeId: 10, Name: 'Vacancies-Launch', FriendlyName: 'Vacancies - Launch To Live' },
    { PrivilegeId: 13, Name: 'Vacancies-PSL', FriendlyName: 'Vacancies – Launch To PSL' },

    { PrivilegeId: 1000, Name: 'System', FriendlyName: 'System' },
];
